export default __webpack_public_path__ + "static/media/music-Room_W112-SILENTBOARD.8bfc7fee.jpg";